import Router from 'lib/Router';

import View from 'view/page/view';

export default Router.extend({
	routes: {
		'page/:id': 'executeView'
	},

	unsecure: [ 'executeView' ],

	executeView: function( id )
	{
		var page = new Backbone.Model( app.getStore('data').get( id ) );

		if( !page.get('body') )
		{
			return console.error404();
		}

		var view = new View({
			model: page
		});

		app.render( view );
		app.history.push( Backbone.history.getHash() );
	},

});
